import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";

export const Container = ({ className = "", children }) => (
  <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${className}`}>{children}</div>
);

export const Section = ({ className = "", children, ...props }) => (
  <section className={`py-20 sm:py-24 lg:py-28 ${className}`} {...props}>{children}</section>
);

export const Overline = ({ children, className = "" }) => (
  <p className={`text-xs font-bold uppercase tracking-[0.2em] text-zoc-teal ${className}`}>{children}</p>
);

export const GradientBar = ({ className = "" }) => (
  <div className={`h-1 w-14 rounded-full zoc-gradient-bar ${className}`} />
);

export const PrimaryLink = ({ to, children, testid, className = "", onClick }) => (
  <Link
    to={to}
    data-testid={testid}
    onClick={onClick}
    className={`group inline-flex items-center gap-2 rounded-full bg-[#0B2A4E] text-white px-6 py-3 font-medium shadow-sm transition-colors duration-200 hover:bg-[#08203B] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zoc-teal focus-visible:ring-offset-2 ${className}`}
  >
    {children}
    <ArrowRight weight="bold" className="transition-transform duration-200 group-hover:translate-x-0.5" />
  </Link>
);

export const SecondaryLink = ({ to, children, testid, className = "", onClick }) => (
  <Link
    to={to}
    data-testid={testid}
    onClick={onClick}
    className={`inline-flex items-center gap-2 rounded-full bg-white text-[#0B2A4E] border border-slate-200 px-6 py-3 font-medium shadow-sm transition-all duration-200 hover:border-zoc-teal hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zoc-teal focus-visible:ring-offset-2 ${className}`}
  >
    {children}
  </Link>
);

export const Eyebrow = ({ children }) => (
  <span className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1 text-xs font-semibold text-slate-600 shadow-sm">
    <span className="h-1.5 w-1.5 rounded-full bg-zoc-green" />
    {children}
  </span>
);
